<template>
	<div>
		<!--工具条-->
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input v-model="inputMac" placeholder="请输入Mac地址" prefix-icon="el-icon-search" size="small"></el-input>
				</el-form-item>
				<el-form-item>
				<el-date-picker v-model="Time" size="small" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
    			</el-form-item>
				<el-form-item>
					<!--<el-button type="primary" size="small" @click="Find">查询</el-button>-->
					<el-button type="primary" size="small" @click="BeforeFind" icon="el-icon-search">搜索</el-button>
				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 99.9%;" :max-height="maxHeight">
		    <el-table-column fixed label="设备Mac地址" prop="mac" width="150"></el-table-column>
			<el-table-column label="站立" width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.d1 == 0">未站立</span>
					<span v-if="scope.row.d1 == 1">已站立</span>
					<span v-if="scope.row.d1 == 3">久站</span>
				</template>
			</el-table-column>
			<el-table-column label="GPS信号" prop="d2" width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.d2 == '[,]' || scope.row.d2 == '[0,0]'">室内</span>
					<span v-if="scope.row.d2 != '[,]' && scope.row.d2 != '[0,0]'">
						{{scope.row.d2}}
						<el-button type="primary" size="mini" icon="el-icon-search" style="padding: 2px;" @click="showmap(scope.$index,scope.row)"></el-button>
					</span>
				</template>
			</el-table-column>
			<el-table-column label="基站信号" prop="d3" width="120"></el-table-column>
			<el-table-column label="电机驱动" width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.d4 == 0">正常</span>
					<span v-if="scope.row.d4 == 1">异常</span>
				</template>
			</el-table-column>
			<el-table-column label="左电机" width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.d5 == 0">正常</span>
					<span v-if="scope.row.d5 == 1">丢失</span>
				</template>
			</el-table-column>
			<el-table-column label="右电机" width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.d6 == 0">正常</span>
					<span v-if="scope.row.d6 == 1">丢失</span>
				</template>
			</el-table-column>
			<el-table-column label="can驱动器" width="110">
				<template slot-scope="scope">
					<span v-if="scope.row.d7 == 0">正常</span>
					<span v-if="scope.row.d7 == 1">丢失</span>
				</template>
			</el-table-column>
			<el-table-column label="can下控" width="100">
				<template slot-scope="scope">
					<span v-if="scope.row.d8 == 0">正常</span>
					<span v-if="scope.row.d8 == 1">丢失</span>
				</template>
			</el-table-column>
			<el-table-column label="can485网关" width="120">
				<template slot-scope="scope">
					<span v-if="scope.row.d9 == 0">正常</span>
					<span v-if="scope.row.d9 == 1">丢失</span>
				</template>
			</el-table-column>
			<el-table-column label="485地址" prop="d10" width="100"></el-table-column>
			<el-table-column label="限速" width="70">
				<template slot-scope="scope">
					<span v-if="scope.row.d11 == 0">忽略</span>
					<span v-if="scope.row.d11 == 1">限速</span>
				</template>
			</el-table-column>
			<el-table-column label="推行" width="70">
				<template slot-scope="scope">
					<span v-if="scope.row.d12 == 0">忽略</span>
					<span v-if="scope.row.d12 == 1">推行</span>
				</template>
			</el-table-column>
			<el-table-column label="锁定" width="70">
				<template slot-scope="scope">
					<span v-if="scope.row.d13 == 0">忽略</span>
					<span v-if="scope.row.d13 == 1">锁定</span>
				</template>
			</el-table-column>
			<el-table-column label="低压" width="70">
				<template slot-scope="scope">
					<span v-if="scope.row.d14 == 0">忽略</span>
					<span v-if="scope.row.d14 == 1">低压</span>
				</template>
			</el-table-column>
			<el-table-column label="蓝牙电量低" width="110">
				<template slot-scope="scope">
					<span v-if="scope.row.d15 == 0">忽略</span>
					<span v-if="scope.row.d15 == 1">电量低</span>
				</template>
			</el-table-column>
			<el-table-column label="颠簸数" width="80">
				<template slot-scope="scope">
					<span>{{scope.row.d16}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="倾斜数" width="80">
				<template slot-scope="scope">
					<span>{{scope.row.d17}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="急转数" width="80">
				<template slot-scope="scope">
					<span>{{scope.row.d18}} 次</span>
				</template>
			</el-table-column>
			<el-table-column label="速度档位" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.d19}} 档</span>
				</template>
			</el-table-column>
			<el-table-column label="设备电池" width="320">
				<template slot-scope="scope">
					<span>{{scope.row.d20}}</span>
					<el-button style="padding: 6px;font-size: 10px;" size="mini" type="primary" @click="Detail(scope.$index,scope.row)">详情</el-button>
				</template>
			</el-table-column>
			<el-table-column label="摆臂电位器" width="110">
				<template slot-scope="scope">
					<span v-if="scope.row.d21 == 0">直立</span>
					<span v-if="scope.row.d21 == 1">摆下</span>
				</template>
			</el-table-column>
			<el-table-column label="座椅电位器" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.d22}} %</span>
				</template>
			</el-table-column>
			<el-table-column label="左缠绕带电位器" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.d23}} %</span>
				</template>
			</el-table-column>
			<el-table-column label="右缠绕带电位器" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.d24}} %</span>
				</template>
			</el-table-column>
			<el-table-column label="版本标识" width="110">
				<template slot-scope="scope">
					<span>{{scope.row.d25 == 2 ? "电动推杆版":scope.row.d25}}</span>
				</template>
			</el-table-column>
			<el-table-column fixed="right" label="时间" prop="time" width="180" :formatter="dateFormat"></el-table-column>
  		</el-table>
		
		<!--工具条-->
  		<el-col :span="24" class="toolbar downtool">
			<el-pagination layout="prev, pager, next,jumper" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		<!--电池情况-->
		<el-dialog title="电池详情" :visible.sync="Bateryvisable" width="35%">
			<el-row>
				<el-col :span="12">
			  		<div>电池电压：{{dianya}}V</div>
			 	</el-col>
			 	<el-col :span="12">
			  		<div>电池电流：{{dianliu}}A</div>
			 	</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
			  		<div>剩余电量：{{dianliang}}%</div>
			 	</el-col>
			 	<el-col :span="12">
			  		<div>电池温度：{{wendu}}°</div>
			 	</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
			  		<div>充电状态：<span v-if="this.chongdian == 1">充电中</span><span v-if="this.chongdian == 0">未充电</span></div>
			 	</el-col>
			 	<el-col :span="12">
			  		<div>电池节数：{{chuan}}串</div>
			 	</el-col>
			</el-row>
			<el-row>
				<el-col :span="24">
			  		<div>充电警报：</div>
				</el-col>
			</el-row>
			<el-row>
			  	<el-col :span="13" :offset="2"><div>电压报警、压差保护、断线保护：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.a == 0">正常</span><span v-if="this.a == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>充电fet损坏报警：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.b == 0">正常</span><span v-if="this.b == 1" style="color: red;">错误</span></div></el-col>
			</el-row>	
			<el-row>
			  	<el-col :span="13" :offset="2"><div>SD：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.c == 0">正常</span><span v-if="this.c == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>ML5238通信：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.d == 0">正常</span><span v-if="this.d == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>E2PROM：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.e == 0">正常</span><span v-if="this.e == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>充电学习状态：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.g == 0">正常</span><span v-if="this.g == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
			<el-row>
				<el-col :span="13" :offset="2"><div>放电学习状态：</div></el-col>
			  	<el-col :span="4"><div><span v-if="this.h == 0">正常</span><span v-if="this.h == 1" style="color: red;">错误</span></div></el-col>
			</el-row>
		</el-dialog>
		
		<el-dialog title="GPS" :visible.sync="Mapvisable" :before-close="Backchange">
			<div style="width: 100%;height: 500px;background: #009E94;">
				<div id="allmap" style="width: 100%;height: 500px"></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {GetDevlogslist} from '../api/api';
	
	export default {
		data(){
			return{
				token:"",
				maxHeight:600,
				Time:"",
				listloading:false,
				total:1,
				Curpage:1,
				Pagesize:20,
				inputMac:"",
				List:[],
				Findform:"",
				Bateryvisable:false,
				dianya:"",
				dianliu:"",
				dianliang:"",
				wendu:"",
				chongdian:"",
				battery:{
					d20:""
				},
				chuan:"",
            	jiexi:"",
            	a:"",
            	b:"",
            	c:"",
            	d:"",
            	e:"",
            	f:"",
            	g:"",
            	h:"",
            	Form:{
            		d2:""
            	},
            	Mapvisable:false,
            	timer:"",
            	outtime:"",
            	Betweenall:{},
            	Screenall:{}
			}
		},
		beforeRouteLeave(to,from,next){
        	clearInterval(this.timer)
        	next()
        },
		methods:{
			Detail(index,row){
				this.Bateryvisable = true
				this.battery = Object.assign({}, row)
				var arr = this.battery.d20
				var arr2 = arr.substring(1,arr.length-1).split(",");
				this.dianya = parseFloat((parseInt(arr2[0],16) * 256 + parseInt(arr2[1],16)) * 0.1).toFixed(1)
				this.dianliu  = parseFloat((parseInt(arr2[2],16) * 256 + parseInt(arr2[3],16)) * 0.1).toFixed(1)
				this.dianliang = parseInt(arr2[4],16)
				this.wendu = parseInt(arr2[5],16) - 40
				this.chongdian = arr2[6]
				this.chuan = arr2[7]
				var str = parseInt(arr2[15],16)
				str & 1 ? this.a = 1 : this.a = 0
				str & 2 ? this.b = 1 : this.b = 0
				str & 4 ? this.c = 1 : this.c = 0
				str & 8 ? this.d = 1 : this.d = 0
				str & 16 ? this.e = 1 : this.e = 0
				str & 32 ? this.f = 1 : this.f = 0
				str & 64 ? this.g = 1 : this.g = 0
				str & 128 ? this.h = 1 : this.h = 0
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Find()
			},
			BeforeFind(){
				this.Curpage = 1
				this.Find()
			},
			Find(){
				if(this.Time){
					this.Betweenall = {"BETWEEN":{'time':[this.Time[0]/1000,this.Time[1]/1000]}}
				}else{
					this.Betweenall = {"BETWEEN":{}}
				}
				if(this.inputMac){
					this.Screenall = {"AND":{'mac':'~' + this.inputMac}}
				}else{
					this.Screenall = {"AND":{}}
				}
				var ever = [this.Screenall,this.Betweenall]
				var ever2 = JSON.stringify(ever)
				if(this.Screenall || this.Betweenall){
					this.GetList(GetDevlogslist,{page:this.Curpage,token:this.token,sort:"-time",q:ever2})
				}else{
					this.GetList(GetDevlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
				}
			},
			Inloop(){
				this.Find()
			},
			Loop(){
				this.timer = setInterval(() => {this.Inloop()},30000)
			},
			Refresh(){
				this.Time = ""
				this.inputMac = ""
				this.Curpage = 1
				this.GetList(GetDevlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
			},
//			显示地图
			showmap(index,row){
				this.Mapvisable = true
				this.Form = Object.assign({}, row);
				clearInterval(this.timer)
				this.outtime = setTimeout(() => {this.ready()},500)
			},
			Backchange(){
				clearTimeout(this.outtime);
				this.Loop()
				this.Mapvisable = false
			},
			ready() {
				var a = this.Form.d2;
				a = (a.substring(1,a.length - 1)).split(",");
//				this.GPSchange(a)
		    	var map = new BMap.Map('allmap');
				var point = new BMap.Point(a[1], a[0]);
		    	map.centerAndZoom(new BMap.Point(a[1], a[0]), 13);
//		      	map.addControl(new BMap.MapTypeControl());
//		      	map.setCurrentCity('上海');
		      	map.enableScrollWheelZoom(true);
		      	map.enableDoubleClickZoom(true);
		      	var marker = new BMap.Marker(point);
		      	map.addOverlay(marker);
		      	marker.setAnimation(BMAP_ANIMATION_BOUNCE);
		   },
//			GPSchange(data){
//				var a = data
//				a = (a.substring(1,a.length - 1)).split(",");  
//				console.log("a[0]",a[0])
//				console.log("a[1]",a[1])
//			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.GetList(GetDevlogslist,{page:this.Curpage,token:this.token,sort:"-time"})
			this.Loop()
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// EquipmentCycleLog.vue?0b92d1af